package ai.wagemix.net.models

import ai.wagemix.net.WMIdentifiable
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/*
select i.id, i.naics_code, i.naics_title, ig.description as group_discription, ig.group_flags
from industries i
join industry_groups ig
  on i.industry_group_id = ig.id;
 */

interface WMIndustry: WMIdentifiable<Int> {
    val groupFlags: Int
    val industryType: String
    val naicsCode: String
    val naicsTitle: String
    companion object
}

fun WMIndustry.Companion.kxs(
    groupFlags: Int,
    id: Int,
    industryType: String,
    naicsCode: String,
    naicsTitle: String
): KxsWMIndustry {
    return KxsWMIndustry(
        groupFlags = groupFlags,
        id = id,
        industryType = industryType,
        naicsCode = naicsCode,
        naicsTitle = naicsTitle
    )
}

fun WMIndustry.toKxs() = when (this) {
    is KxsWMIndustry -> this
    else -> WMIndustry.kxs(
        groupFlags = groupFlags,
        id = id,
        industryType = industryType,
        naicsCode = naicsCode,
        naicsTitle = naicsTitle
    )
}


@ConsistentCopyVisibility
@Serializable
data class KxsWMIndustry internal constructor(
    override val groupFlags: Int,
    override val id: Int,
    override val industryType: String,
    override val naicsCode: String,
    override val naicsTitle: String,
): WMIndustry